import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-211fe559"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "module-list"
};
const _hoisted_2 = ["onDragstart", "onDragover", "onDragleave", "onDrop"];
const _hoisted_3 = {
  class: "module-card__header"
};
const _hoisted_4 = {
  class: "module-card__title"
};
const _hoisted_5 = {
  class: "module-card__handle",
  title: "拖拽排序"
};
const _hoisted_6 = {
  class: "module-card__index"
};
const _hoisted_7 = {
  class: "module-card__name"
};
const _hoisted_8 = {
  key: 0,
  class: "module-card__code"
};
const _hoisted_9 = {
  class: "module-card__count"
};
const _hoisted_10 = {
  class: "module-card__actions"
};
const _hoisted_11 = {
  class: "module-card__body"
};
const _hoisted_12 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empty-state__text"
}, "当前栏目暂无模块", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增模块", -1));
import { onUnmounted, ref } from 'vue';
import { Modal } from 'ant-design-vue';
import { AppstoreOutlined, DeleteOutlined, EditOutlined, HolderOutlined, InboxOutlined, PlusOutlined, SwapOutlined } from '@ant-design/icons-vue';
import ParamTable from './ParamTable.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleList',
  props: {
    modules: null,
    paramsByModule: null
  },
  emits: ["add", "edit", "move", "delete", "reorder", "param-add", "param-edit", "param-log", "param-delete"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /**
     * 模块列表组件
     * - 渲染当前栏目下的模块卡片（编号 + 图标 + 名称 + 参数数量）
     * - 每个卡片头部右侧 编辑 / 删除 按钮
     * - 卡片支持 HTML5 拖拽排序（左侧握把图标）
     * - 末尾「+ 新增模块」按钮
     * - 卡片内嵌 ParamTable（参数表格），透传参数级 add/edit/delete 事件给父层
     *
     * Emits：
     *   add / edit / delete         模块级
     *   reorder                     拖拽后的最新顺序
     *   param-add / param-edit / param-log / param-delete  参数级（透传）
     */
    // ===== 拖拽状态 =====
    const draggingId = ref(null); // 当前正在被拖的卡片 id
    const dropTargetId = ref(null); // 鼠标当前悬停的目标卡片 id（用于高亮）
    const reordering = ref(false); // 排序接口请求中，期间禁止再次拖拽
    let isUnmounted = false;
    onUnmounted(() => {
      isUnmounted = true;
    });
    /** 开始拖拽：记录源 id；如果上一次还在请求中，阻止本次拖拽 */
    const onDragStart = (event, id) => {
      if (reordering.value) {
        event.preventDefault();
        return;
      }
      draggingId.value = id;
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move';
        // text/plain 必须 setData 才能让 Firefox 触发 drop 事件
        event.dataTransfer.setData('text/plain', String(id));
      }
    };
    /** 拖到某卡片上方：高亮目标 */
    const onDragOver = id => {
      if (draggingId.value == null || draggingId.value === id) return;
      dropTargetId.value = id;
    };
    /** 离开目标：取消高亮 */
    const onDragLeave = id => {
      if (dropTargetId.value === id) dropTargetId.value = null;
    };
    /**
     * 放下：计算新顺序后 emit 给父层
     * 算法：从源 index 拿出元素，插入到目标 index
     * 接口请求期间用 reordering 防连拖
     */
    const onDrop = async targetId => {
      const fromId = draggingId.value;
      dropTargetId.value = null;
      draggingId.value = null;
      if (reordering.value) return;
      if (fromId == null || fromId === targetId) return;
      const ids = props.modules.map(m => m.id);
      const fromIdx = ids.indexOf(fromId);
      const toIdx = ids.indexOf(targetId);
      if (fromIdx < 0 || toIdx < 0) return;
      // 把源位置元素抽出，插到目标位置
      const reordered = [...ids];
      const [moved] = reordered.splice(fromIdx, 1);
      reordered.splice(toIdx, 0, moved);
      reordering.value = true;
      try {
        await emit('reorder', reordered);
      } finally {
        if (!isUnmounted) reordering.value = false;
      }
    };
    /** 拖拽结束（无论是否成功 drop）：清理高亮态 */
    const onDragEnd = () => {
      draggingId.value = null;
      dropTargetId.value = null;
    };
    /**
     * 删除模块
     * 二次确认；onOk 返回 Promise 让确定按钮自动 loading 防连点
     */
    const handleDelete = m => {
      Modal.confirm({
        title: '确认删除模块',
        content: `确定要删除模块「${m.moduleName || '未命名模块'}」吗？此操作不可恢复。`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        centered: true,
        onOk: () => Promise.resolve(emit('delete', m))
      });
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modules, (m, idx) => {
        return _openBlock(), _createElementBlock("section", {
          key: m.id,
          class: _normalizeClass(["module-card", {
            'is-dragging': draggingId.value === m.id,
            'is-drop-target': dropTargetId.value === m.id
          }]),
          draggable: true,
          onDragstart: $event => onDragStart($event, m.id),
          onDragover: _withModifiers($event => onDragOver(m.id), ["prevent"]),
          onDragleave: $event => onDragLeave(m.id),
          onDrop: _withModifiers($event => onDrop(m.id), ["prevent"]),
          onDragend: onDragEnd
        }, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_unref(HolderOutlined))]), _createElementVNode("span", _hoisted_6, _toDisplayString(String(idx + 1).padStart(2, '0')), 1), _createVNode(_unref(AppstoreOutlined), {
          class: "module-card__icon"
        }), _createElementVNode("span", _hoisted_7, _toDisplayString(m.moduleName || '(未命名模块)'), 1), m.moduleCode ? (_openBlock(), _createElementBlock("code", _hoisted_8, _toDisplayString(m.moduleCode), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_9, _toDisplayString((__props.paramsByModule[String(m.id)] || []).length) + " 项参数", 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
          size: "small",
          type: "text",
          class: "action-btn",
          onClick: $event => _ctx.$emit('move', m)
        }, {
          icon: _withCtx(() => [_createVNode(_unref(SwapOutlined))]),
          default: _withCtx(() => [_createTextVNode(" 移动 ")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_a_button, {
          size: "small",
          type: "text",
          class: "action-btn",
          onClick: $event => _ctx.$emit('edit', m)
        }, {
          icon: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
          default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_a_button, {
          size: "small",
          type: "text",
          class: "action-btn action-btn--danger",
          onClick: $event => handleDelete(m)
        }, {
          icon: _withCtx(() => [_createVNode(_unref(DeleteOutlined))]),
          default: _withCtx(() => [_createTextVNode(" 删除 ")]),
          _: 2
        }, 1032, ["onClick"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(ParamTable, {
          params: __props.paramsByModule[String(m.id)] || [],
          onAdd: $event => _ctx.$emit('param-add', m),
          onEdit: p => _ctx.$emit('param-edit', {
            module: m,
            param: p
          }),
          onLog: p => _ctx.$emit('param-log', {
            module: m,
            param: p
          }),
          onDelete: p => _ctx.$emit('param-delete', {
            module: m,
            param: p
          })
        }, null, 8, ["params", "onAdd", "onEdit", "onLog", "onDelete"])])], 42, _hoisted_2);
      }), 128)), !__props.modules.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_unref(InboxOutlined), {
        class: "empty-state__icon"
      }), _hoisted_13])) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "module-add",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('add'))
      }, [_createVNode(_unref(PlusOutlined)), _hoisted_14])]);
    };
  }
});